export default {
  data() {
    return {};
  },
  computed: {
    package_type() {
      let package_type = [
        { text: 'Bundle (Time)', value: 'time' },
        { text: 'PPU (Free)', value: 'free' },
        { text: 'Donation (WoS)', value: 'donation', disabled: true },
      ];
      return package_type;
    },
    eligible_provider_types() {
      let eligible_provider_types = [
        { text: 'Psychologist', value: 'psychologist' },
        { text: 'Psychiatrist', value: 'psychiatrist' },
      ];
      return eligible_provider_types;
    },
    refresh_quota_options() {
      let refresh_quota_options = [
        { text: 'No refresh', value: null },
        { text: 'Weekly', value: 'weekly' },
        { text: 'Monthly', value: 'monthly' },
        { text: 'Yearly', value: 'yearly' },
      ];
      return refresh_quota_options;
    },
  },
  methods: {},
};
